import React, { useState } from "react";
import Slider from "react-slick";
import "../styles/MainCategoriesCarousel.css";
import EweProductCard from "../components/EweProductCard";

const ProductCarousel = ({ eweProducts, cart, setCart, isLoggedIn, refreshCart,   handleGlobalAddToCart,
                                                                                  user,
                                                                                  guestCartId   }) => {
  const [loading, setLoading] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // Settings for the carousel
const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  const handleAddToCart = async (product) => {
    if (!product) return;
    setLoading(true);

    try {
      // Check stock availability
      if (product.anStock <= 0) {
        alert('Ovaj proizvod nije dostupan');
        return;
      }

      const productId = product.id || product.anProductKey;
      if (!productId) {
        throw new Error('Invalid product ID');
      }

      // Get the correct price to use
      const price = product.anPrice || product.price;
      const retailPrice = product.anRetailPrice || price;
      const finalPrice = retailPrice <= 0 ? price :
                       (price > retailPrice && price > 0) ? price : retailPrice;

      // Prepare payload
      const payload = {
        productId: productId.toString(),
        name: product.acName || product.name,
        price: finalPrice,
        quantity: 1,
        isEweProduct: !!product.anProductKey,
        imageUrl: getProductImage(product) // Helper function to get image URL
      };

      // Make the API call with credentials
      const response = await fetch(`${API_BASE_URL}/cart/add`, {
        method: 'POST',
        credentials: 'include', // Crucial for cookies
        headers: {
          'Content-Type': 'application/json',
          ...(localStorage.getItem('token') && {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          })
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to add to cart');
      }

      // Refresh cart after successful addition
      if (refreshCart) {
        await refreshCart();
      }

    } catch (error) {
      console.error('Error adding to cart:', error);
      alert(`Greška pri dodavanju u korpu: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };
const getProductImage = (product) => {
  const cleanCode = product.acProduct?.replace(/[^a-zA-Z0-9]/g, '');
  if (cleanCode) {
    return `https://resource.ewe.rs/products/${cleanCode}.jpg`;
  }
  if (product.urlImages?.[0]?.url) {
    return product.urlImages[0].url;
  }
  return '/noImage.jpg';
};
  if (loading) return <div className="loading-spinner">Loading...</div>;

 return (
     <div className="product-carousel">
       <h2>Preporučeni proizvodi</h2>
       <Slider {...carouselSettings}>
         {eweProducts.map(product => (
           <div key={product.anProductKey} className="carousel-item">
             <EweProductCard
               product={product}
               cart={cart}
               setCart={setCart}
               isLoggedIn={isLoggedIn}
               refreshCart={refreshCart}
                 handleGlobalAddToCart={handleGlobalAddToCart}
                 user={user}               // Add this
                 guestCartId={guestCartId} // Add this
             />
           </div>
         ))}
       </Slider>
     </div>
   );
 };

export default ProductCarousel;